import { Checkbox } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { ChangeEvent } from 'react';

import { useLoggedInEmployeeId } from '~/components/Auth';
import { EmployeeCollaborationTaskStatus } from '~/data/collaboration';
import { useSelectedEmployeeId } from '~/hooks/employee';
import {
  WorkListTableRow,
  WorkListTableRowType,
  submitEmployeeWorkListTask,
  workListRoleAccess,
} from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/data';

export const WorklistCheckboxCell = (
  params: GridRenderCellParams<WorkListTableRow> & {
    onUpdate: () => void;
  },
): JSX.Element => {
  const { row, value, field, onUpdate } = params;
  const { rowType, status, responsible, taskData, locked } = row;

  const loggedInEmployeeId = useLoggedInEmployeeId();

  const {
    selectedEmployeeDetails: { hasRoleAccessOverEmployee },
  } = useSelectedEmployeeId();

  const canCreateWorkList = hasRoleAccessOverEmployee(
    workListRoleAccess.canCreateWorkList,
  );
  const canMarkAsResponsible = loggedInEmployeeId === responsible;
  const canMarkTask = (canMarkAsResponsible || canCreateWorkList) && !!taskData;

  const handleCheckBoxToggle = (
    _event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    const getNewState = (): EmployeeCollaborationTaskStatus => {
      if (checked) {
        switch (field) {
          case 'skipped':
            return EmployeeCollaborationTaskStatus.Skipped;
          case 'done':
            return EmployeeCollaborationTaskStatus.Completed;
          default:
            return EmployeeCollaborationTaskStatus.InProgress;
        }
      }

      return EmployeeCollaborationTaskStatus.InProgress;
    };

    if (!!taskData && !!taskData.fTaskId) {
      const updatedTaskData = {
        ...taskData,
        taskState: {
          ...taskData.taskState,
          fTaskStatus: getNewState(),
        },
      };

      submitEmployeeWorkListTask(updatedTaskData)
        .then((_res) => {
          onUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  switch (rowType) {
    case WorkListTableRowType.Task:
      return (
        <Checkbox
          checked={value}
          onChange={handleCheckBoxToggle}
          disabled={!canMarkTask || locked}
        />
      );
    case WorkListTableRowType.List:
      return field === 'done' ? <>{status ?? ''}</> : <></>;
    default:
      return <></>;
  }
};
